module.exports = __webpack_public_path__ + "static/a4-302ec96553541033454838dd40f640a4.png";